import React from "react";
import Select from "react-select";
import { Answer } from "../../apis";

type Props = {
  options: Array<Option>;
  answerQuestion: (answer: Answer) => Promise<void>;
  initSelect?: Option;
};

export const NumericChoiceSelect: React.FC<Props> = ({
  options,
  answerQuestion,
  initSelect,
}) => (
  <Select
    options={options}
    value={initSelect}
    isMulti={false}
    isSearchable={false}
    onChange={(e) => {
      const newSelect = e as Option;

      const answer = {
        questionType: "NUMERIC_CHOICE",
        value: newSelect.value,
      };

      answerQuestion({ answer });
    }}
    placeholder={""}
  />
);
